import React, { useState } from 'react';
import useEscaneosStore from '../../store/escaneosStore';
import { useAuth } from '../../auth/AuthProvider';

const CouponModal = ({ isOpen, onClose, coupon, onMarkAsUsed }) => {
  const { enviarCodigoPromocion, insertarCuponCliente, handleSave } = useEscaneosStore();
  const auth = useAuth();
  const esAdmin = auth.user?.tipo === 1 || auth.user?.tipo === 2;

  const [validationCode, setValidationCode] = useState('');
  const [showValidationInput, setShowValidationInput] = useState(false);
  const [error, setError] = useState('');

  if (!isOpen || !coupon) return null;

  const handleMarkAsUsed = async() => {
    console.log('El coupon',coupon);

    if (esAdmin) {
      let respuesta = await insertarCuponCliente(coupon.id, '');
      console.log('La respuesta',respuesta);
      if (respuesta && respuesta.data && respuesta.data[0] && respuesta.data[0].RESULT == 1) {
        handleSave();
        onClose();
      } else {
        setError('Error al aplicar el cupón manualmente');
      }
      return;
    }

    if (!showValidationInput) {
      enviarCodigoPromocion();
      setShowValidationInput(true);
      return;
    }

    // Basic validation - in a real app, you'd validate against your backend
    if (!validationCode.trim()) {
      setError('Por favor ingresa un código de validación');
      return;
    }
    
    let respuesta = await insertarCuponCliente(coupon.id,validationCode);
    console.log('La respuesta',respuesta);

    if(respuesta.data[0].RESULT == 1){
      handleSave()
      onClose();
    }
    else{
      setError('Código de validación incorrecto');
      return;
    }
  };

  const handleCancel = () => {
    setShowValidationInput(false);
    setValidationCode('');
    setError('');
  };

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{coupon.title}</h5>
            <button 
              type="button" 
              className="btn-close" 
              onClick={onClose}
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <div className="mb-4">
              <h6>Descripción:</h6>
              <p>{coupon.description}</p>
            </div>
            
            <div className="row g-1 mb-4">

              <div className="col-12">
                <div className="p-3 bg-light rounded">
                  <div className="text-muted small fw-semibold">Aplican términos y condiciones</div>
                  <div className="fw-normal">{coupon.terms}</div>
                </div>
              </div>
            </div>

            {showValidationInput && (
              <div className="mb-4">
                <label htmlFor="validationCode" className="form-label fw-semibold">
                  Código de validación
                </label>
                <input
                  type="text"
                  className={`form-control ${error ? 'is-invalid' : ''}`}
                  id="validationCode"
                  value={validationCode}
                  onChange={(e) => {
                    setValidationCode(e.target.value);
                    if (error) setError('');
                  }}
                  placeholder="Ingresa el código de validación"
                  autoFocus
                />
                {error && <div className="invalid-feedback">{error}</div>}
                <div className="form-text mt-1">
                  Verifica el código con el cliente antes de continuar.
                </div>
              </div>
            )}
          </div>
          <div className="modal-footer">
            {showValidationInput ? (
              <button 
                type="button" 
                className="btn btn-outline-secondary" 
                onClick={handleCancel}
              >
                Cancelar
              </button>
            ) : (
              <button 
                type="button" 
                className="btn btn-outline-secondary" 
                onClick={onClose}
              >
                Cerrar
              </button>
            )}
            <button 
              type="button" 
              className="btn btn-primary"
              onClick={handleMarkAsUsed}
            >
              {esAdmin ? 'Aplicar descuento (Admin)' : (showValidationInput ? 'Confirmar' : 'Marcar como usado')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CouponModal;
